import { call, put } from "redux-saga/effects";
import { authApi } from "@services/api";
import { confirmValidatorActions } from "../slices";
import { has } from "lodash";

function* confirmValidatorWorker({ payload }) {
  try {
    yield put(confirmValidatorActions.pending());
    const response = yield call(authApi.confirmValidator, payload);
    yield put(confirmValidatorActions.success(response));
    // TODO: handle callback | onSuccess
    if (has(payload, "onSuccess")) {
      payload.onSuccess();
    }
  } catch (error) {
    yield put(confirmValidatorActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { confirmValidatorWorker };
